import Vue from "vue";
import Router from "vue-router";
import Home from "../views/user/Home";
import CallScreen from '../views/user/CallingScreen'
import CallHistory from '../views/user/CallHistory';

import PartnerLogin from "../views/partner/PartnerLogin";
import PartnerCallingScreen from "../views/partner/PartnerCallingScreen";
Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/",
    //   name: "Welcome",
    //   component: Welcome
    // },
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/call-history",
      name: "CallHistory",
      component: CallHistory
    },
    {
      path: "/calling-screen",
      name: "CallingScreen",
      component: CallScreen
    },
    {
      path: "/partner-login",
      name: "PartnerLogin",
      component: PartnerLogin
    },
    {
      path: "/partner-calling-screen/:id",
      name: "PartnerCallingScreen",
      component: PartnerCallingScreen
    }
  ]
});
